package io.horion.cv.components.preview

import androidx.compose.runtime.Composable
import io.horion.cv.uiState.LetterUiState
import io.horion.cv.utils.orDefault
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul
import org.jetbrains.compose.web.css.*

@Composable
fun LetterProfessionalPreview(letterUiState: LetterUiState){
    Div(attrs = {
        style {
            property("width", "794px")
            property("min-height", "1123px")
            property("font-family", "Georgia, serif")
            property("font-size", "18px")
            property("background", "#ffffff")
            property("color", "#000000")
            property("padding", "50px 60px")
            property("box-sizing", "border-box")
            property("background-image", "url('/LettreProfesssionnelVide.jpeg')")
            property("background-size", "100% 100%")
            property("background-repeat", "no-repeat")
            property("background-position", "center")
            property("word-wrap", "break-word")
            property("overflow-wrap", "break-word")
            property("white-space", "normal")
            property("word-break", "break-word")
            property("line-height", "1.2")
        }
    }) {

        // Nom prenom
        Div(attrs = {
            style {
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-word")
            }
        }) {
            Text(letterUiState.data.personalInformation.lastName.orDefault("prenom"))
        }
        Br {}

        Div(attrs = {
            style {
                property("font-weight", "bold")
                property("text-transform", "uppercase")
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-word")
            }
        }) {
            Text(letterUiState.data.personalInformation.firstName.uppercase().orDefault("NOM "))
        }
        Br {}

        // Code postal, adresse
        Div(attrs = {
            style {
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-word")
            }
        }) {
            Text(letterUiState.data.personalInformation.bp.orDefault("codePostal ") + ", " + letterUiState.data.personalInformation.address.orDefault("Ville "))
        }
        Br {}

        // numero de telephone
        Div(attrs = {
            style {
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
            }
        }) {
            Text("Tel : ")
            Text(letterUiState.data.personalInformation.phone.orDefault("Numero "))
        }
        Br {}

        // adresse email
        Div(attrs = {
            style {
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-all")
            }
        }) {
            Text("Mail : ")
            Text(letterUiState.data.personalInformation.email.orDefault("adresse email"))
        }
        Br {}

        // entreprise a droite
        Div(attrs = {
            style {
                property("text-align", "right")
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-word")
            }
        }) {
            Text("Monsieur le directeur des ressources humaines de ")
            Br {}
            Text(letterUiState.enterprise.orDefault("Entreprise "))
        }
        Br {}

        // ville ,Date
        Div(attrs = {
            style {
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
            }
        }) {
            Text(letterUiState.data.personalInformation.city.orDefault("Ville ") + ", " + letterUiState.data.date.orDefault("Date "))
        }
        Br {}
        Br {}

        // Objet
        Div(attrs = {
            style {
                property("font-weight", "bold")
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-word")
            }
        }) {
            Text("Objet : " + letterUiState.data.subject)
        }
        Br {}
        Br {}

        // 1er paragraphe INTRODUCTION
        HtmlBlock(
            letterUiState.data.introduction.orDefault(
                "Je vous prie de bien vouloir considérer ma candidature pour un poste au sein de votre entreprise. Disposant d'une réelle motivation pour évoluer dans un environnement professionnel exigeant, je souhaite mettre à profit mes compétences, mon sens des responsabilités et ma capacité d'adaptation au service de votre équipe. "
            )
        ) {
            property("word-wrap", "break-word")
            property("overflow-wrap", "break-word")
            property("white-space", "normal")
            property("word-break", "break-word")
        }
        Br {}
        Br {}

        // 2e paragraphe SITUATION
        HtmlBlock(
            letterUiState.data.situation.orDefault(
                "Au cours de mes expériences précédentes, j'ai développé un sens aigu de l'organisation, de la rigueur et de la collaboration. Habitué(e) à travailler avec des objectifs clairs, je veille à respecter les délais et à maintenir un haut niveau de qualité dans les tâches qui me sont confiées. Mon aisance relationnelle me permet également de collaborer efficacement avec des interlocuteurs variés."
            )
        ) {
            property("word-wrap", "break-word")
            property("overflow-wrap", "break-word")
            property("white-space", "normal")
            property("word-break", "break-word")
        }
        Br {}
        Br {}

        // 3e paragraphe MOTIVATION
        HtmlBlock(
            letterUiState.data.motivation.orDefault(
                "Consciencieux(se) et impliqué(e), je suis prêt(e) à m'investir pleinement pour contribuer aux résultats de votre structure et à m'intégrer rapidement à vos méthodes de travail."
            )
        ) {
            property("word-wrap", "break-word")
            property("overflow-wrap", "break-word")
            property("white-space", "normal")
            property("word-break", "break-word")
        }
        Br {}
        Br {}

        // Remerciement CONCLUSION
        HtmlBlock(
            letterUiState.data.conclusion.orDefault(
                "Je vous remercie par avance de l'attention portée à cette candidature et reste à votre disposition pour un entretien."
            )
        ) {
            property("word-wrap", "break-word")
            property("overflow-wrap", "break-word")
            property("white-space", "normal")
            property("word-break", "break-word")
        }
        Br {}
        Br {}

        // Formule de politesse
        Div(attrs = {
            style {
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
            }
        }) {
            Text("Veuillez agréer, Madame, Monsieur, l'expression de mes salutations distinguées.")
        }
        Br {}
        Br {}

        // piece jointe
        Div(attrs = {
            style {
                property("text-decoration", "underline")
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
            }
        }) {
            Text("Pieces Jointes : ")
        }
        Br {}

        Div(attrs = {
            style {
                property("margin-top", "10px")
                property("margin-bottom", "10px")
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
            }
        }) {
            Ul {
                letterUiState.data.others.forEach { item ->
                    Li(attrs = {
                        style {
                            property("word-wrap", "break-word")
                            property("overflow-wrap", "break-word")
                            property("white-space", "normal")
                            property("word-break", "break-word")
                        }
                    }) {
                        Text(item)
                    }
                }
            }
        }

        // nom et prenom
        Div(attrs = {
            style {
                property("text-align", "right")
                property("word-wrap", "break-word")
                property("overflow-wrap", "break-word")
                property("white-space", "normal")
                property("word-break", "break-word")
            }
        }) {
            Text(letterUiState.data.personalInformation.firstName.orDefault("Nom").uppercase() + " " + letterUiState.data.personalInformation.lastName.orDefault("prenom"))
        }
    }
}